<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="healthTable"
          title="건강 유해성"
          :merge="grid.merge"
          :columns="grid.columns"
          :data="ghsClassBase.healthGhsClassBase"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable"
          selection="multiple"
          rowKey="mdmGhsClassficationBaseId"
          @table-data-change="dataChange"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable" 
                :showLoading="false" 
                label="추가" 
                icon="add" 
                @btnClicked="addHealthGhsClassBase" />
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSaveHealth"
                :param="saveData.health"
                mappingType="PUT"
                label="저장"
                icon="save"
                @beforeAction="saveHealthGhsClassBaseInfo"
                @btnCallback="saveHealthGhsClassBaseCallback" />
              <c-btn 
                v-if="editable" 
                label="삭제" 
                icon="remove" 
                @btnClicked="deleteHealthGhsClassBase" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="envTable"
          title="환경 유해성"
          :merge="grid.merge"
          :columns="grid.columns"
          :data="ghsClassBase.envGhsClassBase"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable"
          selection="multiple"
          rowKey="mdmGhsClassficationBaseId"
          @table-data-change="dataChange"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable" 
                :showLoading="false" 
                label="추가" 
                icon="add" 
                @btnClicked="addEnvGhsClassBase" />
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSaveEnv"
                :param="saveData.env"
                mappingType="PUT"
                label="저장"
                icon="save"
                @beforeAction="saveEnvGhsClassBaseInfo"
                @btnCallback="saveEnvGhsClassBaseCallback" />
              <c-btn 
                v-if="editable" 
                label="삭제" 
                icon="remove" 
                @btnClicked="deleteEnvGhsClassBase" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chem-ghs-3',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        plantCd: '',
        plantName: '',
        materialCd: '',
        materialName: '',
        productCategoryCd: '',
        isSaved: '',
        updateFlag: '',
      }),
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'mdmGhsClassficationBaseId' },
        ],
        columns: [
          {
            name: 'sourceName',
            field: 'sourceName',
            label: '유해·위험성 분류',
            align: 'left',
            style: 'width:150px',
            type: 'textarea',
            sortable: false,
          },
          {
            name: 'chemNmEn',
            field: 'chemNmEn',
            description: 'casNo',
            label: '화학물질명',
            align: 'left',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'sourceTxt',
            field: 'sourceTxt',
            label: '유해·위험성 분류 근거 내용',
            align: 'left',
            style: 'width:300px',
            type: 'textarea',
            sortable: false,
          },
        ],
      },
      substances: [],
      ghsClassBase: {
        healthGhsClassBase: [],
        envGhsClassBase: [],
      },
      saveData: {
        health: [],
        env: [],
      },
      editable: false,
      isSaveHealth: false,
      isSaveEnv: false,
      subListUrl: '',
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.subListUrl = selectConfig.mdm.mam.chem.substance.url;
      this.listUrl = selectConfig.mdm.ghs.db.list;
      this.saveUrl = transactionConfig.mdm.ghs.db.save;
      this.deleteUrl = transactionConfig.mdm.ghs.db.delete;
      // code setting
      // list setting
      this.getSubstances();
      this.getList();
    },
    getSubstances() {
      this.$http.url = this.subListUrl;
      this.$http.type = 'GET';
      this.$http.param = {mdmChemMaterialId: this.param.mdmChemMaterialId};
      this.$http.request((_result) => {
        this.$_.extend(this.substances, _result.data)
      },);
    },
    getList(type) {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        mdmChemMaterialId: this.param.mdmChemMaterialId
      };
      this.$http.request((_result) => {
        if (type === 'health') {
          this.$set(this.ghsClassBase, 'healthGhsClassBase', this.$_.filter(_result.data, {sourceType : '건강 유해성' }))
        } else if (type === 'env') {
          this.$set(this.ghsClassBase, 'envGhsClassBase', this.$_.filter(_result.data, {sourceType : '환경 유해성' }))
        } else {
          this.$set(this.ghsClassBase, 'healthGhsClassBase', this.$_.filter(_result.data, {sourceType : '건강 유해성' }))
          this.$set(this.ghsClassBase, 'envGhsClassBase', this.$_.filter(_result.data, {sourceType : '환경 유해성' }))
        }
      },);
    },
    dataChange(props, col) {
      if (col.name === 'sourceName' && props.row['baseEditFlag'] !== 'C') {
        props.row['baseEditFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      } if (col.name === 'sourceTxt' && props.row['unitEditFlag'] !== 'C') {
        props.row['unitEditFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      } else {
        // nothing...
      }
    },
    addHealthGhsClassBase() {
      let _mdmGhsClassficationBaseId = uid();
      this.$_.forEach(this.substances, substance => {
        this.ghsClassBase.healthGhsClassBase.splice(0, 0, {
          mdmGhsClassficationBaseId: _mdmGhsClassficationBaseId,
          mdmChemMaterialId: this.param.mdmChemMaterialId,
          sourceType: '건강 유해성',
          sourceName: '',
          casNo: substance.casNo,
          chemNmKr: substance.chemNmKr,
          chemNmEn: substance.chemNmEn,
          sourceTxt: '',
          baseEditFlag: 'C',
          unitEditFlag: 'C',
          regUserId: this.$store.getters.user.userId,
        })
      })
    },
    addEnvGhsClassBase() {
      let _mdmGhsClassficationBaseId = uid();
      this.$_.forEach(this.substances, substance => {
        this.ghsClassBase.envGhsClassBase.splice(0, 0, {
          mdmGhsClassficationBaseId: _mdmGhsClassficationBaseId,
          mdmChemMaterialId: this.param.mdmChemMaterialId,
          sourceType: '환경 유해성',
          sourceName: '',
          casNo: substance.casNo,
          chemNmKr: substance.chemNmKr,
          chemNmEn: substance.chemNmEn,
          sourceTxt: '',
          baseEditFlag: 'C',
          unitEditFlag: 'C',
          regUserId: this.$store.getters.user.userId,
        })
      })
    },
    saveHealthGhsClassBaseInfo() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          // 저장 데이터 초기화
          Object.assign(this.$data.saveData, this.$options.data().saveData);
          let filterData = this.$_.filter(this.ghsClassBase.healthGhsClassBase, item => {
            return Boolean(item.baseEditFlag) || Boolean(item.unitEditFlag)
          })
          this.$_.forEach(filterData, base => {
            if (this.$_.findIndex(this.saveData.health, { mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId }) === -1) {
              this.saveData.health.push({
                mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId,
                mdmChemMaterialId: base.mdmChemMaterialId,
                sourceType: base.sourceType,
                sourceName: base.sourceName,
                regUserId: base.regUserId,
                chgUserId: base.chgUserId,
                editFlag: base.baseEditFlag,
                baseUnits: this.$_.map(this.$_.filter(filterData, { mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId }), (unit) => {
                  return {
                    mdmGhsClassficationBaseId: unit.mdmGhsClassficationBaseId,
                    mdmChemMaterialId: unit.mdmChemMaterialId,
                    sourceName: unit.sourceName,
                    casNo: unit.casNo,
                    chemNmKr: unit.chemNmKr,
                    chemNmEn: unit.chemNmEn,
                    sourceTxt: unit.sourceTxt,
                    regUserId: unit.regUserId,
                    chgUserId: unit.chgUserId,
                    editFlag: unit.unitEditFlag
                  }
                })
              })
            }
          })

          this.isSaveHealth = !this.isSaveHealth;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveHealthGhsClassBaseCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList('health');
    },
    deleteHealthGhsClassBase() {
      let selectData = this.$refs['healthTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        let deleteData = this.$_.uniqBy(this.$_.map(selectData, item => {
          return {
            mdmGhsClassficationBaseId: item.mdmGhsClassficationBaseId
          }
        }), 'mdmGhsClassficationBaseId')
        
        this.$http.url = this.deleteUrl;
        this.$http.type = 'DELETE';
        this.$http.param = {
          data: Object.values(deleteData),
        };
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          
          this.$_.forEach(selectData, item => {
            this.ghsClassBase.healthGhsClassBase = this.$_.reject(this.ghsClassBase.healthGhsClassBase, item);
          })
          this.$refs['healthTable'].$refs['compo-table'].clearSelection();
        },);
      }
    },
    saveEnvGhsClassBaseInfo() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          // 저장 데이터 초기화
          Object.assign(this.$data.saveData, this.$options.data().saveData);
          let filterData = this.$_.filter(this.ghsClassBase.healthGhsClassBase, item => {
            return Boolean(item.baseEditFlag) || Boolean(item.unitEditFlag)
          })
          this.$_.forEach(filterData, base => {
            if (this.$_.findIndex(this.saveData.health, { mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId }) === -1) {
              this.saveData.health.push({
                mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId,
                mdmChemMaterialId: base.mdmChemMaterialId,
                sourceType: base.sourceType,
                sourceName: base.sourceName,
                regUserId: base.regUserId,
                chgUserId: base.chgUserId,
                editFlag: base.baseEditFlag,
                baseUnits: this.$_.map(this.$_.filter(filterData, { mdmGhsClassficationBaseId: base.mdmGhsClassficationBaseId }), (unit) => {
                  return {
                    mdmGhsClassficationBaseId: unit.mdmGhsClassficationBaseId,
                    mdmChemMaterialId: unit.mdmChemMaterialId,
                    sourceName: unit.sourceName,
                    casNo: unit.casNo,
                    chemNmKr: unit.chemNmKr,
                    chemNmEn: unit.chemNmEn,
                    sourceTxt: unit.sourceTxt,
                    regUserId: unit.regUserId,
                    chgUserId: unit.chgUserId,
                    editFlag: unit.unitEditFlag
                  }
                })
              })
            }
          })

          this.isSaveEnv = !this.isSaveEnv;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveEnvGhsClassBaseCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList('env');
    },
    deleteEnvGhsClassBase() {
      let selectData = this.$refs['envTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        let deleteData = this.$_.uniqBy(this.$_.map(selectData, item => {
          return {
            mdmGhsClassficationBaseId: item.mdmGhsClassficationBaseId
          }
        }), 'mdmGhsClassficationBaseId')

        this.$http.url = this.deleteUrl;
        this.$http.type = 'DELETE';
        this.$http.param = {
          data: Object.values(deleteData),
        };
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          
          this.$_.forEach(selectData, item => {
            this.ghsClassBase.envGhsClassBase = this.$_.reject(this.ghsClassBase.envGhsClassBase, item);
          })
          this.$refs['envTable'].$refs['compo-table'].clearSelection();
        },);
      }
    },
  }
};
</script>

<style lang="sass">
.ghsClassBasedetail
  padding-bottom:10px !important
.card-chem-unit-title
  flex: 0.4
  font-size: 1rem
  font-weight: 600
.card-chem-unit-info
  flex: 0.6
  // flex: 10000 1 0%
  font-size: 0.9rem
  font-weight: 400
.detail-chem-unit
  width: auto
  min-width: 0
  max-width: 100%
  display: flex
  border-radius: 10px
  height: auto
.card-title-text
  .q-field__control
    height: 28px
    line-height: 28px
    input
      margin-bottom: 0px !important
  .q-field__append    
    height: 28px
    font-size: 15px
</style>